import { DeleteOutstationComponent } from './../delete-outstation/delete-outstation.component';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UpdatOutstationComponent } from '../updat-outstation/updat-outstation.component';
import { DepartmentsService } from 'src/app/admin/data/services/departments.service';
import { AddOutstationComponent } from '../add-outstation/add-outstation.component';
import { TokenStorageService } from 'src/app/core/service/token-storage.service';
import { LevelNameService } from 'src/app/authentication/otp/level-name.service';
import { AddButton, TableAction, TableColumn } from 'src/app/shared/components/table/table.component';
import * as XLSX from "xlsx";

@Component({
  selector: 'app-view-outstation',
  templateUrl: './view-outstation.component.html',
  styleUrls: ['./view-outstation.component.sass']
})
export class ViewOutstationComponent implements OnInit {
  addButtons: AddButton[] = [];
  columns: TableColumn[] = [
    { field: "id", header: "ID", sortable: true},
    { field: "outstationName", header: "", sortable: true},
    { field: "outstationLocation", header: "Location", sortable: true}
  ]

  actions: TableAction[] = [

  ]

  displayedColumns: string[] = ['id', 'name', 'location', 
    // 'actions'
  ];
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  contextMenu: MatMenuTrigger;
  contextMenuPosition = { x: "0px", y: "0px" };
  subscription!: Subscription;
  selection = new SelectionModel<any>(true, []);
  data: any[] = [];
  error: any;

  formData: any;

  isLoading: boolean = false;

  parentLevelLabel: string = '';
  childLevelLabel: string = '';
  stationLabel: string = ''




  constructor(
    private router: Router,
    private ngZone: NgZone,
    private deptService: DepartmentsService, private dialog: MatDialog,    private tokenStorage: TokenStorageService,
    private levelNameService: LevelNameService
  ) { }

  ngOnInit(): void {
    const levelNames = this.levelNameService.getLevelNames();
    console.log('Level names returned:', levelNames);

    if (levelNames) {
      this.parentLevelLabel = levelNames.parentLevelName || 'Parent';
      this.childLevelLabel = levelNames.childLevelName || 'Child';
      this.stationLabel = this.childLevelLabel;
      console.log('Assigned childLevelLabel:', this.childLevelLabel);
      
      this.columns[1].header = this.childLevelLabel;
    } else {
      console.warn('Level names are null or undefined!');
    }
    
    this.getData();
    this.addButtons = [
      {
        text: 'Bulk Upload',
        callback: () => this.router.navigate(['/admin/outstation/upload-setup']),
      },
    ];
  }
  ngOnDestroy(): void {
    //this.subscription.unsubscribe();
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  getData() {
    var parishId = this.tokenStorage.getUser().parishId;

    this.subscription = this.deptService.getOutstation(parishId).subscribe(res => {
      this.data = res;
      console.log("Fetched outstations:", res);
      const sortedData = res.sort((a, b) => b.id - a.id);
      this.data = sortedData.map((outstation, index) => ({
        ...outstation,
        id: index + 1
      }));
  

      if (this.data) {
        this.isLoading = false;
      }


      // Binding with the datasource
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }


  deleteOutstation(outstationData: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '500px';
    dialogConfig.data = {
      test: outstationData
    };
    //check if click on delete icon was taken up
    console.log("Delete Outstation inititated")

    const dialogRef = this.dialog.open(DeleteOutstationComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // If the delete operation was successful, refresh the data
        this.getData();
      }
    });
  }

  update(data: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true
    dialogConfig.autoFocus = true
    dialogConfig.width = '500px'
    dialogConfig.height = '400px'
    dialogConfig.data = {
      // test:this.assetDetail
      test: data
    }

    const dialogRef = this.dialog.open(UpdatOutstationComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.getData();
    });
    console.log("Onselect implemented")

  }

  refresh() {
    this.getData();
    //console.log("Table Refreshed")
  }



  addOutstation() {
    (document.activeElement as HTMLElement)?.blur();
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true
    dialogConfig.autoFocus = true
    dialogConfig.width = '500px'
    dialogConfig.data = {
      // test:this.assetDetail
      test: "data"
    }

    const dialogRef = this.dialog.open(AddOutstationComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      this.getData();
      }
    });
  }

 
  onSelect() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false
    dialogConfig.autoFocus = true
    dialogConfig.width = '500px'
    dialogConfig.height = '400px'
  
      this.router.navigate([`./admin/outstation/outstation-details`]);
    }

    downloadExcel(): void {
      const data = this.data.map((outstations) => {
        const row = {};
        this.columns.forEach((col) => {
          row[col.header] = outstations[col.field];
        });
        return row;
      });
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, this.childLevelLabel);
      XLSX.writeFile(wb, `${this.childLevelLabel}_Report.xlsx`);
    }

  }





